import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "cart-input"
};
const _hoisted_2 = { class: "cart-input__price" };
const _hoisted_3 = { class: "cart-input__unit-price" };
const _hoisted_4 = ["title"];
const _hoisted_5 = {
    key: 1,
    class: "cart-input__original-unit-price"
};
const _hoisted_6 = { class: "cart-input__unit" };
const _hoisted_7 = {
    key: 0,
    class: "cart-input__price-select"
};
const _hoisted_8 = ["tabindex"];
const _hoisted_9 = ["value"];
import { onMounted, ref, watch } from 'vue';
import ArticleQuantityInput from "./ArticleQuantityInput.vue";
import productUtils from '../services/ProductUtils';
import products from '../services/ProductRepository';
import Price from "./Price.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ArticleCartInput',
    props: {
        variant: {},
        unitCode: {},
        initialQuantity: {},
        cart: {},
        tabIndex: {},
        allowOrderingUnitSelection: { type: Boolean },
        considerUnavailabilityReasons: { type: Boolean }
    },
    emits: [
        'change',
        'focus',
        'blur',
    ],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const orderingUnits = ref([]);
        const orderingUnit = ref(null);
        const quantityConfig = ref({
            initial: 1,
            max: 0,
            min: 0,
            decimals: 0,
        });
        const itemDraft = ref(null);
        const price = ref('');
        onMounted(onVariantChange);
        watch(() => props.variant, onVariantChange);
        function onVariantChange() {
            orderingUnits.value = props.variant.orderingUnits;
            orderingUnit.value = orderingUnits.value.find(p => p.unitCode === props.variant.baseOrderingUnit) || orderingUnits.value[0];
            // initState() is triggered by @Watch('orderingUnit')
        }
        watch(() => props.unitCode, onUnitCodeChange);
        function onUnitCodeChange() {
            const unitCode = props.unitCode || props.variant.baseOrderingUnit;
            orderingUnit.value = orderingUnits.value.find(p => p.unitCode === unitCode) || orderingUnits.value[0];
        }
        function onQuantityChange(quantity) {
            const createNewDraft = !itemDraft.value;
            if (createNewDraft) {
                initState();
            }
            quantityConfig.value.initial = quantity.quantity;
            quantityConfig.value.portions = quantity.portions;
            itemDraft.value.quantity = quantity.quantity;
            itemDraft.value.portions = quantity.portions;
            emit('change', itemDraft.value);
            updatePrice();
        }
        function onValidityChange(validity) {
            if (!validity) {
                itemDraft.value = null;
            }
            else {
                initState();
            }
            emit('change', itemDraft.value);
        }
        watch(() => orderingUnit.value, onOrderingUnitChange);
        function onOrderingUnitChange() {
            initState();
        }
        function isAvailable() {
            if (props.considerUnavailabilityReasons) {
                return true;
            }
            return props.variant.availability.available;
        }
        function initState() {
            let initial = getInitialQuantity((itemDraft.value && itemDraft.value.quantity) || undefined);
            if (orderingUnit.value) {
                quantityConfig.value = productUtils.createQuantityConfig(initial, props.variant, orderingUnit.value);
            }
            else {
                quantityConfig.value = { initial: 0, max: 0, min: 0, decimals: 0, };
            }
            quantityConfig.value.decimals = orderingUnit.value ? orderingUnit.value.unitDecimals : 0;
            // minimum should not be more than the initial value
            if (quantityConfig.value.min !== undefined) {
                quantityConfig.value.min = Math.min(quantityConfig.value.min, initial);
            }
            if (orderingUnit.value) {
                itemDraft.value = {
                    sku: props.variant.sku,
                    quantity: itemDraft.value ? itemDraft.value.quantity : quantityConfig.value.initial,
                    unit: orderingUnit.value.unitCode,
                };
            }
            updatePrice();
            emit('change', itemDraft.value);
        }
        function getInitialQuantity(prevQuantity) {
            let initialQuantity = props.variant.defaultOrderQuantity || 1;
            if (orderingUnit.value && orderingUnit.value.portioning === 'required') {
                initialQuantity = 0;
            }
            else if (prevQuantity) {
                initialQuantity = prevQuantity;
            }
            else if (props.initialQuantity !== undefined) {
                initialQuantity = props.initialQuantity;
            }
            return initialQuantity;
        }
        function updatePrice() {
            if (!itemDraft.value || !itemDraft.value.quantity || itemDraft.value.quantity <= 0) {
                price.value = orderingUnit.value.price.unitPrice;
                return;
            }
            // try to prevent unnecessary price updates
            if (orderingUnit.value.price.unitCode === itemDraft.value.unit
                && itemDraft.value.quantity + '' === orderingUnit.value.minimumQuantity
                && (props.variant.defaultOrderQuantity === 1 || props.variant.defaultOrderQuantity === null)) {
                price.value = orderingUnit.value.price.unitPrice;
                return;
            }
            const requestProps = {
                sku: itemDraft.value.sku,
                quantity: itemDraft.value.quantity,
                unit: itemDraft.value.unit,
            };
            products
                .getVariantPrice(requestProps.sku, requestProps.quantity, requestProps.unit, props.cart ? props.cart.channel : undefined, props.cart ? {
                currency: props.cart.currency,
                priceGroups: props.cart.customer.priceGroups,
                date: props.cart.shippingMethod.targetDate,
            } : undefined)
                .then(p => {
                // update price only if we're still showing the same parameters
                if (requestProps.sku === itemDraft.value?.sku
                    && requestProps.quantity === itemDraft.value?.quantity
                    && requestProps.unit === itemDraft.value?.unit) {
                    price.value = p.price;
                }
            });
        }
        return (_ctx, _cache) => {
            const _component_icon = _resolveComponent("icon");
            const _directive_b_tooltip = _resolveDirective("b-tooltip");
            return (orderingUnit.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("span", _hoisted_3, [
                            _createVNode(Price, {
                                currency: orderingUnit.value.price.currency,
                                amount: price.value
                            }, null, 8, ["currency", "amount"])
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (orderingUnit.value.price.individual)
                            ? _withDirectives((_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "cart-input__is-individual-price",
                                title: _ctx.$t('product.price_individual')
                            }, [
                                _createVNode(_component_icon, {
                                    name: "star",
                                    "icon-style": "solid"
                                })
                            ], 8, _hoisted_4)), [
                                [
                                    _directive_b_tooltip,
                                    void 0,
                                    void 0,
                                    {
                                        hover: true,
                                        top: true
                                    }
                                ]
                            ])
                            : _createCommentVNode("", true),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (orderingUnit.value.price.originalUnitPrice)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(orderingUnit.value.price.originalUnitPrice) + " " + _toDisplayString(orderingUnit.value.price.currency), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createVNode(ArticleQuantityInput, {
                        onChange: onQuantityChange,
                        onValidityChange: onValidityChange,
                        sku: __props.variant.sku,
                        unitCode: orderingUnit.value.unitCode,
                        config: quantityConfig.value,
                        available: isAvailable(),
                        "reset-on-cart-item-added": true,
                        "reset-portions-on-close": true,
                        "tab-index": __props.tabIndex,
                        "apply-inventory-updates": true,
                        onFocus: _cache[0] || (_cache[0] = ($event) => (emit('focus'))),
                        onBlur: _cache[1] || (_cache[1] = ($event) => (emit('blur')))
                    }, null, 8, ["sku", "unitCode", "config", "available", "tab-index"]),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                        (orderingUnits.value.length === 1 || !__props.allowOrderingUnitSelection)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$unit(orderingUnit.value)), 1))
                            : _withDirectives((_openBlock(), _createElementBlock("select", {
                                key: 1,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((orderingUnit).value = $event)),
                                class: "cart-input-field cart-input__price-select",
                                tabindex: __props.tabIndex
                            }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderingUnits.value, (ou, index) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: index,
                                        value: ou
                                    }, _toDisplayString(_ctx.$unit(ou)), 9, _hoisted_9));
                                }), 128))
                            ], 8, _hoisted_8)), [
                                [_vModelSelect, orderingUnit.value]
                            ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
